<section id="norton360Details" class="rs-es-first-section">
  <div class="row">
    <div class="columns small-12">
      <h1 class="rs-tit1-sp rs-txt-c2">{{ 'norton360.title' | translate }}</h1>
      <div class="rs-panel-big rs-bg-c2 clearfix">
        <p>
          {{ 'norton360.account.description.label' | translate }}
        </p>
        <div class="rs-flex-row">
          <div class="rs-flex-columns small-12 medium-4">
            <mprd-norton360-my-account></mprd-norton360-my-account>
          </div>
          <div class="rs-flex-columns small-12 medium-8">
            <mprd-norton360-subscription></mprd-norton360-subscription>
          </div>
        </div>
      </div>
      <div class="rs-le2"></div>
    </div>
  </div>
</section>
